export default {
        base_url: 'http://api.scgzzx.cn'
        //base_url: 'http://scgzzx.cn/api/'
       //base_url: 'http://118.89.227.14:2018'
}



// WEBPACK FOOTER //
// ./src/conf.js